import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2, FolderInput, RotateCcw } from "lucide-react";

export const BulkCategoryBar = ({ selected, onDone }) => {
  const [cats, setCats] = useState([]);
  const [slug, setSlug] = useState("");
  const [busy, setBusy] = useState("");

  useEffect(() => {
    api.get("/admin/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const act = async (key, body, ok) => {
    setBusy(key);
    try {
      const r = await api.post("/admin/products/categories/bulk", { product_ids: selected, ...body });
      toast.success(`${r.data.updated} ${ok}`);
      onDone?.();
    } catch (e) {
      toast.error(e.response?.data?.detail || "That didn't work");
    } finally { setBusy(""); }
  };

  return (
    <div className="bg-brand-green/10 border border-brand-green/30 rounded-xl p-3 mb-4 flex flex-wrap items-center gap-3"
      data-testid="bulk-category-bar">
      <FolderInput className="w-4 h-4 text-brand-green" />
      <span className="text-sm">{selected.length} selected — add them to</span>
      <Select value={slug} onValueChange={setSlug}>
        <SelectTrigger className="w-56 h-9 bg-white" data-testid="bulk-category-select">
          <SelectValue placeholder="Category" />
        </SelectTrigger>
        <SelectContent className="bg-white">
          {cats.map((c) => <SelectItem key={c.slug} value={c.slug}>{c.name}</SelectItem>)}
        </SelectContent>
      </Select>
      <Button size="sm" className="bg-brand-green hover:bg-brand-greendark rounded-full gap-2"
        disabled={!slug || busy === "add"} data-testid="bulk-category-apply"
        onClick={() => act("add", { add: [slug] }, "products moved")}>
        {busy === "add" ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Move
      </Button>
      <Button size="sm" variant="outline" className="rounded-full gap-2"
        disabled={!slug || busy === "remove"} data-testid="bulk-category-remove"
        onClick={() => act("remove", { remove: [slug] }, "products removed from it")}>
        Remove from
      </Button>
      <Button size="sm" variant="outline" className="rounded-full gap-2"
        disabled={busy === "revert"} data-testid="bulk-category-revert"
        onClick={() => act("revert", { revert: true }, "products back on automatic filing")}>
        <RotateCcw className="w-3.5 h-3.5" /> Revert to automatic
      </Button>
    </div>
  );
};
